/*@ngInject*/
const PolicyRewriteActionsRepository = function ($q, baseSharedPromiseRepository, currentSubmissionModel) {

    let sharedPromiseCache = {};

    angular.extend(this, baseSharedPromiseRepository);

    this.getGETSharedPromiseCache = function () {
        return sharedPromiseCache;
    };

    this.loadPolicyRewriteActions = function (policyRewriteId) {
        const url = `/rest/Actions?uri=com.firstbest.underwriting.policy.rewrite.PolicyRewrite:${policyRewriteId}&registrationIdentifier=/PolicyRewrite/${policyRewriteId}`,
            cacheKey = `policyRewriteActions:${policyRewriteId}`;

        if (currentSubmissionModel.hasActionsRegistration(`/PolicyRewrite/${policyRewriteId}`)) {
            return $q.resolve(null);
        } else {
            return this.get(cacheKey, url).then(function (responseData) {
                currentSubmissionModel.addActionsRegistration(`/PolicyRewrite/${policyRewriteId}`, url);
                return responseData;
            });
        }
    };
};

angular.module('gw-um-submission')
    .service('policyRewriteActionsRepository', PolicyRewriteActionsRepository);
